import React from "react";

export const Header = (props) => {
  return (
    <header id="header">
            <div className="col-md-4">
                <div id="row">
                    {props.data ? props.data.map((d, i) => (
                        <div key={`${d.name}-${i}`} className="col-md-12 col-sm-6 team">
                            <div className="Thumbnail">
                                {" "}
                                <img src={d.img} alt="..." className="team-img" />
                                <div className="caption">
                                    <h4>{d.name}</h4>
                                    <p style={{textAlign:"center", fontWeight:500, fontSize:16.5}}>{d.job}</p>
                                </div>
                            </div>
                        </div>
                    ))
                    : "loading"}
                </div>
            </div>
            <div className="col-md-8">
                <div className="intro">
                    <div className="overlay">
                        <div className="container">
                            <div className="col-md-12 col-md-offset-2 intro-text">
                                <h3>Olá</h3>
                                <h3>
                                    Somos a Tuboflex, especialista na fabricação e comercialização de tubos de papelão, tubetes e arruelas. Nossos produtos podem ser personalizados em até três cores, impresso internamente ou externamente, temos a opção neutra também, sem personalização.
                                </h3>
                                <br/>
                                <h3>
                                    Atendemos empresas de diversos segmentos, entre elas: Rotulos e fitas adesivas, embalagens flexíveis, papel, papel alumínio, têxtil, fiação, indústria plástica, filme strech, lonas e borrachas, linha hospitalar, construção civil, TNT (Tecido não tecido), entre outros.
                                </h3>
                                <br/>
                                <h3>
                                    Estamos prontos para desenvolver seu produto sob medida.
                                </h3>
                                <br/>
                                <h3>
                                    Está em dúvida se conseguimos lhe atender? Entre em contato pelo formulário abaixo, ou diretamente pelo Whatsapp, no canto direito superior desta tela.
                                </h3>
                                <p>
                                <img 
                                    src="../img/logo-no_bg-color.png"
                                    alt="Logo Tuboflex"
                                    style={{ maxWidth: '500px', marginLeft: '80px' }}
                                />
                                </p>
                                {/* <h2>Quem Somos</h2>
                                <p>Somos a Tuboflex, especializada na fabricação e comercialização de tubos de papelão espirais, estamos localizados na cidade de Vinhedo, ponto estratégico para atender todo estado de São Paulo e demais estados, devido a excelente malha viária e aérea que nos circunda.
                                Atendendo a diversos segmentos embalagens flexíveis, papel, papel alumínio, têxtil, fiação, fitas, etiquetas adesivas, indústria plástica, filme strech, fiação, lonas e borrachas, industrias de papel, linha hospitalar, construção civil, TNT (Tecido não tecido) e outros segmentos.
                                </p>
                                <br/><br/>
                                <h2>Produtos</h2>
                                <p>Fabricamos tubetes, tubos e arruelas de papel personalizados até três cores, internamente ou externamente, temos também a opção neutra (sem personalização).
                                Todos nossos tubetes são finalizados com papel semi-kraft ou papel branco, conferindo um excelente acabamento e maior rigidez a deformações.
                                </p> */}
                            </div>              
                        </div>
                    </div>
                </div>
            </div>
        
      {/* <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <h1>
                <img 
                src="../img/logo-no_bg.png"
                alt="Logo Tuboflex"
                style={{ maxWidth: '800px', height: 'auto' }}
            />
                  {props.data ? props.data.title : "Loading"}
                  <span></span>
                </h1>
                <p>{props.data ? props.data.paragraph : "Loading"}</p>
                <a
                  href="#features"
                  className="btn btn-custom btn-lg page-scroll"
                >
                  Saiba Mais
                </a>{" "}
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </header>
  );
};
